'use strict';

var _createForOfIteratorHelper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var withIs = require('class-is');

var Topology = require('./index');

var MulticodecTopology = /*#__PURE__*/function (_Topology) {
  _inherits(MulticodecTopology, _Topology);

  var _super = _createSuper(MulticodecTopology);

  /**
   * @param {Object} props
   * @param {number} props.min minimum needed connections (default: 0)
   * @param {number} props.max maximum needed connections (default: Infinity)
   * @param {Array<string>} props.multicodecs protocol multicodecs
   * @param {Object} props.handlers
   * @param {function} props.handlers.onConnect protocol "onConnect" handler
   * @param {function} props.handlers.onDisconnect protocol "onDisconnect" handler
   * @constructor
   */
  function MulticodecTopology(_ref) {
    var _this;

    var min = _ref.min,
        max = _ref.max,
        multicodecs = _ref.multicodecs,
        handlers = _ref.handlers;

    _classCallCheck(this, MulticodecTopology);

    _this = _super.call(this, {
      min: min,
      max: max,
      handlers: handlers
    });

    if (!multicodecs) {
      throw new Error('one or more multicodec should be provided');
    }

    if (!handlers) {
      throw new Error('the handlers should be provided');
    }

    if (typeof handlers.onConnect !== 'function') {
      throw new Error('the \'onConnect\' handler must be provided');
    }

    if (typeof handlers.onDisconnect !== 'function') {
      throw new Error('the \'onDisconnect\' handler must be provided');
    }

    _this.multicodecs = Array.isArray(multicodecs) ? multicodecs : [multicodecs];
    _this._registrar = undefined;
    _this._onProtocolChange = _this._onProtocolChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MulticodecTopology, [{
    key: "registrar",
    set: function set(registrar) {
      this._registrar = registrar;

      this._registrar.peerStore.on('change:protocols', this._onProtocolChange); // Update topology peers


      this._updatePeers(this._registrar.peerStore.peers.values());
    }
    /**
     * Update topology.
     * @param {Array<PeerInfo>} peerInfoIterable
     * @returns {void}
     */

  }, {
    key: "_updatePeers",
    value: function _updatePeers(peerInfoIterable) {
      var _this2 = this;

      var _iterator = _createForOfIteratorHelper(peerInfoIterable),
          _step;

      try {
        var _loop = function _loop() {
          var peerInfo = _step.value;

          if (_this2.multicodecs.filter(function (multicodec) {
            return peerInfo.protocols.has(multicodec);
          }).length) {
            // Add the peer regardless of whether or not there is currently a connection
            _this2.peers.set(peerInfo.id.toB58String(), peerInfo); // If there is a connection, call _onConnect


            var connection = _this2._registrar.getConnection(peerInfo);

            connection && _this2._onConnect(peerInfo, connection);
          } else {
            // Remove any peers we might be tracking that are no longer of value to us
            _this2.peers.delete(peerInfo.id.toB58String());
          }
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    /**
     * Check if a new peer support the multicodecs for this topology.
     * @param {Object} props
     * @param {PeerInfo} props.peerInfo
     * @param {Array<string>} props.protocols
     */

  }, {
    key: "_onProtocolChange",
    value: function _onProtocolChange(_ref2) {
      var _this3 = this;

      var peerInfo = _ref2.peerInfo,
          protocols = _ref2.protocols;
      var existingPeer = this.peers.get(peerInfo.id.toB58String());
      var hasProtocol = protocols.filter(function (protocol) {
        return _this3.multicodecs.includes(protocol);
      }); // Not supporting the protocol anymore?

      if (existingPeer && hasProtocol.length === 0) {
        this._onDisconnect(peerInfo);
      } // New to protocol support


      var _iterator2 = _createForOfIteratorHelper(protocols),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var protocol = _step2.value;

          if (this.multicodecs.includes(protocol)) {
            this._updatePeers([peerInfo]);

            return;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }]);

  return MulticodecTopology;
}(Topology);

module.exports = withIs(MulticodecTopology, {
  className: 'MulticodecTopology',
  symbolName: '@libp2p/js-interfaces/topology/multicodec-topology'
});